import React, { useEffect, useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';

const ToastContainer = () => {
  const [ToastComponents, installToastComponents] = useState({});

  useEffect(() => {
    import('react-toastify').then(({ Slide, ToastContainer }) => {
      installToastComponents({
        Slide,
        ToastContainerComponent: ToastContainer,
      });
    });
  }, [installToastComponents]);

  const { Slide, ToastContainerComponent } = ToastComponents;
  if (!ToastContainerComponent) return null;

  return (
    <ToastContainerComponent
      closeButton={false}
      draggable={false}
      hideProgressBar
      newestOnTop
      position="top-center"
      transition={Slide}
    />
  );
};

export default ToastContainer;
